<template>
	<div class="page-in">
		<van-nav-bar
		  :title="$t('团队')"
		  fixed
		  placeholder
		  z-index="99"
		  :border="false"
		  v-if="isMobileFlag"
		/>
		<div class="inside-page" style="background-color: #f4eeea;">
			<div class="layui-container layui-signle-container" >
				<div v-if="!loadingPage">
					<template v-if="Agdata">
						<h1 class="article-title">{{Agdata.title}}</h1>
						<div class="article-content" v-html="Agdata.content"></div>
						<div class="article-button">
							<router-link to="/agency-team" class="layui-btn layui-btn-normal">
								{{$t('进入我的团队')}}
							</router-link>
						</div>
					</template>
				</div>
			</div>
		</div>
		
		<Foot :active="2" v-if="isMobileFlag"/>
	</div>
</template>
<script>
	import Foot from "@/components/Foot.vue";
	import Cooperation from '../Home/components/Cooperation.vue'
	import {index_notice_details_api,index_notice_list_api} from '@/api/index'
	export default {
		components:{
			Foot,
			Cooperation
		},
		data() {
			return {
				Agdata:{},
				cdk:'',
				loadingPage:true
			};
		},
		methods:{
			async getDetailNotice(pageid) {
				let param = {
					id: pageid,
				};
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				const res = await index_notice_details_api(param);
				if (res && res.data.code == 1) {
					this.Agdata = res.data.data
					this.loadingPage = false
					loading.close()
				}else{
					loading.close()
				}
				
			},
			async getNotice() {
				let param = {};
				const res = await index_notice_list_api(param);
				if (res && res.data.code == 1) {
					this.pageid = res.data.data.filter(item => item.is_nav === 2)[0].id;
					this.getDetailNotice(this.pageid)
				}
			}
		},
		mounted() {
			this.getNotice()
		}
	}
</script>
<style scoped>
	.layui-signle-container{
		min-height: 50vh;
	}
</style>
